<div mat-dialog-content class="image-dialog-content">
  <img [src]="data.imageUrl" alt="Modifier Example" class="modifier-image" />
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</div>
